import { ConfigurationValue } from "../../app/slices/fachverfahren/types";

import { isArrayOf, isEnumConfig } from "../typeGuardUtils";

export const RUNTIME_MODULES = {
	DELETE_AUTOMATIC_PROCESS: "AutomatischeVorgaengeLoeschen",
	DELETE_MANUAL_PROCESS: "ManuelleVorgaengeLoeschen"
};

export const RUNTIME_CONFIG_VALUES = {
	DELETE_AUTOMATIC_PROCESS_STATES: "AutomaticProcessDeleteStates",
	DELETE_MANUAL_PROCESS_STATES: "ManualProcessDeleteStates"
};

export function getProcessStatesConfigValue(config: ConfigurationValue) {
	const configurationValue = JSON.parse(config.value);
	if (isArrayOf(isEnumConfig)(configurationValue)) {
		return configurationValue.map(it => it.value);
	}
	return [];
}
